import * as classes from '../sass/main.scss';
import React from "react";
import ReactDOM from "react-dom";
import CollageGalleryApp from "./components/CollageGalleryApp";
import ScreenshotGalleryApp from "./components/ScreenshotGalleryApp";

document.addEventListener("DOMContentLoaded", () => {
    const collageGalleryAppDiv = document.getElementById("collage-gallery-react-app");
    const screenshotGalleryAppDiv = document.getElementById("screenshot-gallery-react-app");

    if (collageGalleryAppDiv) {
        ReactDOM.render(<CollageGalleryApp />, collageGalleryAppDiv);
    }

    // Add this block
    if (screenshotGalleryAppDiv) {
        ReactDOM.render(<ScreenshotGalleryApp />, screenshotGalleryAppDiv);
    }
});
